import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import českých překladů
import commonCS from './locales/cs/common.json';
import formsCS from './locales/cs/forms.json';
import faqCS from './locales/cs/faq.json';
import accountsCS from './locales/cs/accounts.json';
import videosCS from './locales/cs/videos.json';
import messagesCS from './locales/cs/messages.json';

// Import slovenských překladů
import commonSK from './locales/sk/common.json';
import formsSK from './locales/sk/forms.json';
import faqSK from './locales/sk/faq.json';
import accountsSK from './locales/sk/accounts.json';
import videosSK from './locales/sk/videos.json';
import messagesSK from './locales/sk/messages.json';

const resources = {
  cs: {
    common: commonCS,
    forms: formsCS,
    faq: faqCS,
    accounts: accountsCS,
    videos: videosCS,
    messages: messagesCS,
  },
  sk: {
    common: commonSK,
    forms: formsSK,
    faq: faqSK,
    accounts: accountsSK,
    videos: videosSK,
    messages: messagesSK,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'cs',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React již escapuje hodnoty
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
